/**
 * Classe responsável pelo evento de filtro dos grids
 * @returns {Monet.Grid.ActionsModules.FilterGrid}
 * @author adalto.junior
 */


Monet.Grid = Monet.Grid || {};
Monet.Grid.ActionsModules = Monet.Grid.ActionsModules || {};

Monet.Grid.ActionsModules.FilterGrid = function () {

    this.entity = null;
    this.selector = null;
    this.element = null;
    this.screenName = null;

    this.setEntity = function (entity) {
        this.entity = entity;
    };

    this.setSelector = function (selector) {
        this.selector = selector;
    };

    this.setElement = function (element) {
        this.element = element;
    };

    this.setScreenName = function (screenName) {
        this.screenName = screenName;
    };

    this.createInputFilter = function () {

        try {

            if (this.element !== null) {

                var template = '<div class="dataTables_filter"><label><input type="text" id="searchFilter" /></label></div>';
                this.checkElementAndWriteHTML(this.element, template);

            }

        } catch (e) {
            (new Monet.Exception.ReturnError(this, "Error on create input filter")).console();
        }

    };

    this.checkElementAndWriteHTML = function (element, html) {

        if (element !== null) {
            $(element).append(html);
        }

    };

    this.addEventListenners = function () {


        var selector = this.selector + " #searchFilter",
            dataView = null,
            input = null,
            that = this,
            tableType = "",
            tableViewMonitor = App.Views.RouteSummary,
            error = null,
            text = "",
            grid = null,
            entity = null,
            options = Monet.Grid.Utils.paginationOptions,
            initial = options.FIRST,
            maxResult = options.MAX_RESULT;

        try {

            input = document.querySelector(selector);

            if (input !== null) {
                $(input).typeWatch({
                    callback: function () {

                        entity = that.entity;

                        if (typeof (App.Forms[entity]) === "undefined" && entity !== "Maps") {
                            tableType = tableViewMonitor.tableChecker();
                            entity = tableType;
                        }

                        if (entity !== "Maps") {

                            App.Forms[entity].pagination.first = initial;
                            App.Forms[entity].pagination.max = maxResult;
                            grid = App.Forms[entity].table;
                            dataView = App.Forms[entity].dataProvider;
                            dataView.arrayIds = [];
                            text = "";

                            text = App.Objects[entity].getFilter(entity, this.el);

                            grid.removeScrollToGrid();

                            App.Objects[entity].updateGrid(text, Monet.Grid.addDataToGrid);

                        }
                    },
                    wait: 750,
                    captureLength: 0
                }).off('keypress').on('keypress', function (e) {
                        if (e.keyCode === 13) {
                            e.preventDefault();
                        }
                    });
            }


        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on add event listenners to search field");
            error.console();

        }

    };


    this.init = function () {

        if (typeof(this.screenName) === "undefined" || this.screenName === null) {
            this.screenName = Monet.Utils.GetTabName();
        }

        this.createInputFilter();
        this.addEventListenners();

    };

};
